import { Component, OnInit } from '@angular/core';
import { UmsService } from '../ums.service';
import { HttpErrorResponse } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { NgxSpinnerService } from 'ngx-spinner';
import { CourseScheduleDialogBoxComponent } from '../course-schedule-dialog-box/course-schedule-dialog-box.component';
import { PageEvent } from '@angular/material/paginator';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';

@Component({
  selector: 'app-course-schedule',
  templateUrl: './course-schedule.component.html',
  styleUrls: ['./course-schedule.component.scss']
})
export class CourseScheduleComponent implements OnInit {
  APIService: any;
  dialogRef: MatDialogRef<any>;
  coursecheduleList: any;
  filteredListCoSch: any;
  CourseScheduleSearchForm : FormGroup;
  pageSize = 10;
  pageSizeOptions: number[] = [5, 10, 20];
  currentPage = 1;
  totalItems = 0;
  SessionNo: any;
  setIntervalSearch: any;
  constructor(
    public umsService: UmsService, private fb: FormBuilder, 
    private spinner:NgxSpinnerService, private dialog:MatDialog,
     ) { this.APIService = environment.serviceUrl; }

  ngOnInit(): void {
    if(JSON.parse(sessionStorage.getItem("session")) == null){
      this.fetchSecretData();
    }
    else if(JSON.parse(sessionStorage.getItem("session")) != null){
      let sessionData = JSON.parse(sessionStorage.getItem("session"));
      this.SessionNo = sessionData.SnNo
      this.getCoSchData(this.SessionNo)
    }
    this.CourseScheduleSearchForm = this.fb.group({
      SearchString: new FormControl ('')
    });
  }

  fetchSecretData() {
    this.umsService.getSecretData().subscribe((res) => {
      this.SessionNo = res.projectPharam['SnNo']
      this.getCoSchData(this.SessionNo)
      }
    );
  }
 
  onPageChange(event: PageEvent): void {
    this.pageSize = event.pageSize;
    const newPageIndex = event.pageIndex + 1;
    this.currentPage = newPageIndex;
    this.fetchSecretData();
    // this.keypress();
  }

  keypress(){
    if(this.setIntervalSearch){
      clearTimeout(this.setIntervalSearch);
    }
    this.setIntervalSearch = setTimeout(()=>{
      if(this.CourseScheduleSearchForm.value['SearchString'] == '' || this.CourseScheduleSearchForm.value['SearchString'] == null)
        {
          this.spinner.show();
          const payload = {};
          payload['PageSize'] = this.pageSize;
          payload['PageNumber'] = this.currentPage;
          payload['LoginId'] = sessionStorage.getItem('userId');
          payload['CShSnNo'] = this.SessionNo;
          this.umsService.getCourseSch(payload).subscribe(res => {
            this.spinner.hide();
            this.coursecheduleList = res.data;
            this.totalItems = res.data[0].TotalRecords;
            this.filteredListCoSch = this.coursecheduleList.slice();
           
            });
        }
        else{
          let payload = {}
          payload['SearchString'] = this.CourseScheduleSearchForm.value['SearchString'];
          payload['PageSize'] = this.pageSize;
          // payload['PageNumber'] = 1;
          payload['LoginId'] = sessionStorage.getItem('userId');
          payload['CShSnNo'] = this.SessionNo;
          if (payload['SearchString'] === "") {
            payload['PageNumber'] = this.currentPage;
          } else {
            payload['PageNumber'] = 1;
          }
          this.umsService.searchCouSch(payload).subscribe(res => {
            if(res.status){
              this.coursecheduleList = res.data;
              this.totalItems = res.data[0].TotalRecords;
            }
            else{
              this.coursecheduleList = [];
              this.totalItems = 0;
            }
           
            }, (ERROR: HttpErrorResponse) => {
              this.coursecheduleList = [];
            });
        }
       
    },1000)
   
  }
  getCoSchData(SnNo) {
    this.spinner.show();
    const payload = {};
    payload['PageSize'] = this.pageSize;
    payload['PageNumber'] = this.currentPage;
    payload['LoginId'] = sessionStorage.getItem('userId');
    payload['CShSnNo'] = SnNo;
    this.umsService.getCourseSch(payload).subscribe(res => {
      this.spinner.hide();
      this.coursecheduleList = res.data;
      this.totalItems = res.data[0].TotalRecords;
      this.filteredListCoSch = this.coursecheduleList.slice();
      
      });
  }

  addnewrecord() {

    const dialogRef = this.dialog.open(CourseScheduleDialogBoxComponent, {
      width: '90vh',
      data: {key : "New"},
      disableClose: true 
    }); 
    dialogRef.afterClosed().subscribe(result => {
      // Handle dialog close actions or data here
      this.fetchSecretData();
    });
  }
  editData(k){ 
    const dialogRef = this.dialog.open(CourseScheduleDialogBoxComponent, {
      width: '80vh',
      // height:'85vh',
      data: { selected: k, key : "Edit"},
      disableClose: true 
    });
    dialogRef.afterClosed().subscribe(result => {
      // Handle dialog close actions or data 
      this.fetchSecretData();
    });
  }
  deleteData(k){
    const dialogRef = this.dialog.open(CourseScheduleDialogBoxComponent, {
      width: '75vh',
      data: { selected: k, key : "Delete"},
      disableClose: true 
    });
    dialogRef.afterClosed().subscribe(result => {
      // Handle dialog close actions or data here
      this.fetchSecretData();
    });
  }
  
}
